import axios from 'axios';
import { PreCallPlan } from '../models/AppPreCallPlan';

const API_URL = process.env.REACT_APP_SERVER_URL + "/app/precallplans";

const authHeader = () => ({
    Authorization: `Bearer ${localStorage.getItem('gpcwstoken_kw')}`,
});

export const AppPreCallPlanService = {
    getPreCallPlansPaginated: async (
        page: number,
        limit: number,
        search?: string,
        warehouseId?: string | number,
        userId?: string | number
    ): Promise<{ plans: PreCallPlan[]; total: number }> => {
        const params: Record<string, any> = { page, limit };
        if (search) params.search = search;
        if (warehouseId !== undefined && warehouseId !== null && warehouseId !== '') params.warehouseId = warehouseId;
        if (userId !== undefined && userId !== null && userId !== '') params.userId = userId;
        const response = await axios.get(`${API_URL}/getPlansPaginated`, { params, headers: authHeader() });
        return response.data;
    },

    getPreCallPlansForToday: async (): Promise<PreCallPlan[]> => {
        const response = await axios.get(`${API_URL}/getPlansForToday`, { headers: authHeader() });
        return response.data;
    },

    getPreCallPlansForThisWeek: async (): Promise<PreCallPlan[]> => {
        const response = await axios.get(`${API_URL}/getPlansForThisWeek`, { headers: authHeader() });
        return response.data;
    },

    getPreCallPlansByDateRange: async (startDate: string, endDate: string): Promise<PreCallPlan[]> => {
        const response = await axios.get(`${API_URL}/getPlansByDateRange`, {
            params: { startDate, endDate },
            headers: authHeader(),
        });
        return response.data;
    },

    getAllPreCallPlans: async (): Promise<PreCallPlan[]> => {
        const response = await axios.get(`${API_URL}/getAllPlans`, { headers: authHeader() });
        return response.data;
    },

    getPreCallPlanById: async (id: number): Promise<PreCallPlan> => {
        const response = await axios.get(`${API_URL}/getPlanById/${id}`, { headers: authHeader() });
        return response.data;
    },

    createPreCallPlan: async (preCallPlan: Omit<PreCallPlan, 'id' | 'created_time' | 'updated_time'>): Promise<PreCallPlan> => {
        const response = await axios.post(`${API_URL}/add`, preCallPlan, { headers: authHeader() });
        return response.data;
    },

    updatePreCallPlan: async (id: number, preCallPlan: Omit<PreCallPlan, 'id' | 'created_time' | 'updated_time'>): Promise<PreCallPlan> => {
        const response = await axios.put(`${API_URL}/update/${id}`, preCallPlan, { headers: authHeader() });
        return response.data;
    },

    deletePreCallPlan: async (id: number): Promise<void> => {
        await axios.delete(`${API_URL}/delete/${id}`, { headers: authHeader() });
    }
};
